import * as React from "react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { useAuthProvider } from "../../core/authContext";
import {
  useGetDineInCategoriesQuery,
  DineInCategories,
  useDeleteDineInCategoriesMutation,
  useAddDineInCategoriesMutation,
} from "../../generated/graphql";
import useEdible from "../Dine-In-Menu/hotel-edible-hook";
const useCategory = () => {
  const [editData, setEditData] = React.useState<DineInCategories | null>(null);
  const [open, setOpen] = React.useState(false);
  const [isCustomized, setIsCustomized] = React.useState<boolean>(false);
  const handleClickEditOpen = (data: DineInCategories | null) => {
    setEditData(data);
    setOpen(true);
    setIsCustomized(data?.uploaded_icon ? true : false);
  };
  const handleEditClose = () => {
    setEditData(null);
    setOpen(false);
  };

  const { getUser } = useAuthProvider();
  const property = getUser();

  // add categories
  const {
    data: Categories,
    refetch: refetchCategory,
    loading: loadingCategories,
  } = useGetDineInCategoriesQuery({
    fetchPolicy: "network-only",
    variables: {
      propertyID: property?.id,
    },
  });
  const [deleteCategories] = useDeleteDineInCategoriesMutation();

  const { edibleItems } = useEdible();
  const handleDelete = async (id: string, name: string) => {
    const foundCategory = edibleItems?.find((edible) => edible?.type === name);
    if (foundCategory) {
      Swal.fire({
        text: `Here are currently menu items which are linked to this ${name}. 
        Those items will be moved in the Uncategorized section. Are you sure you want to delete ${name} category?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete!",
      }).then((result) => {
        if (result.isConfirmed) {
          (async () => {
            try {
              const res = await deleteCategories({
                variables: {
                  id: id,
                  propertyID: property?.id,
                },
              });

              if (res.data?.deleteDineInCategory) {
                swal({
                  text: "Category Deleted Successfully",
                  icon: "success",
                });
              } else {
                swal({
                  text: "Category Not Deleted ",
                  icon: "error",
                });
              }
              refetchCategory();
            } catch (err) {
              swal({
                text: `Error -${err}`,
                icon: "error",
              });
            }
          })();
        }
      });
    } else {
      Swal.fire({
        text: `Are you sure you want to delete ${name} category?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete!",
      }).then((result) => {
        if (result.isConfirmed) {
          (async () => {
            try {
              const res = await deleteCategories({
                variables: {
                  id: id,
                  propertyID: property?.id,
                },
              });

              if (res.data?.deleteDineInCategory) {
                swal({
                  text: "Category Deleted Successfully",
                  icon: "success",
                });
              } else {
                swal({
                  text: "Category Not Deleted ",
                  icon: "error",
                });
              }
              refetchCategory();
            } catch (err) {
              swal({
                text: `Error -${err}`,
                icon: "error",
              });
            }
          })();
        }
      });
    }
  };

  const [upsertCategories] = useAddDineInCategoriesMutation();

  const onToggleCategories = async (data: DineInCategories) => {
    if (data.is_Activated === false) {
      Swal.fire({
        text: `All items linked to ${data.name} category will also be enabled`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Accept!",
      }).then((result) => {
        if (result.isConfirmed) {
          (async () => {
            try {
              const res = await upsertCategories({
                variables: {
                  dineInCategoriesInput: {
                    id: data?.id || "",
                    name: data.name,
                    icon: data.icon,
                    property_id: property?.id,
                    desc: data?.desc,
                    sequence: data?.sequence,
                    is_Activated: true,
                  },
                },
              });
              if (res.data?.upsertDineInCategory) {
                setOpen(false);
                swal({
                  text: "Category updated Successfully",
                  icon: "success",
                });
              }
              refetchCategory();
            } catch (err) {
              swal({
                text: `${err}`,
                icon: "error",
              });
            }
          })();
        }
      });
    } else {
      try {
        const res = await upsertCategories({
          variables: {
            dineInCategoriesInput: {
              id: data?.id || "",
              name: data.name,
              icon: data.icon,
              property_id: property?.id,
              desc: data?.desc,
              sequence: data?.sequence,
              is_Activated: false,
            },
          },
        });
        if (res.data?.upsertDineInCategory) {
          setOpen(false);
          swal({
            text: "Category updated Successfully",
            icon: "success",
          });
        }
        refetchCategory();
      } catch (err) {
        swal({
          text: `${err}`,
          icon: "error",
        });
      }
    }
  };

  const onSave = async (data: DineInCategories) => { 
    try {
      const res = await upsertCategories({
        variables: {
          dineInCategoriesInput: {
            id: data?.id || "",
            name: data.name,
            icon: data.icon,
            property_id: property?.id,
            desc: data?.desc,
            sequence: data?.sequence,
            is_Activated: data?.is_Activated,
          },
        },
      });
      if (res.data?.upsertDineInCategory) {
        setOpen(false);
        swal({
          text: "Category updated Successfully",
          icon: "success",
        });
      }
    } catch (err) {
      swal({
        text: `${err}`,
        icon: "error",
      });
    }
  };
  return {
    Categories: Categories?.getDineInCategories,
    handleClickEditOpen,
    handleEditClose,
    editData,
    refetchCategory,
    propertyId: property?.id,
    open,
    setOpen,
    loadingCategories,
    handleDelete,
    onSave,
    onToggleCategories,
    isCustomized,
    setIsCustomized,
  };
};

export default useCategory;
